import React, { useContext, useEffect } from 'react';
import intl from 'react-intl-universal';
import './Protocol.scss';
import { createPortal } from 'react-dom';
import { alpha } from '../../utils/color';
import { ThemeContext } from '../../store/ThemeProvider';

interface IUsageProtocol {
  show?: boolean;
  close: () => void;
}
const containerEl = document.createElement('div');
const Protocol = function(props: IUsageProtocol) {
  const { show } = props;
  useEffect(() => {
    document.body.appendChild(containerEl);
    return () => {
      document.body.removeChild(containerEl);
    };
  }, []);
  const { componentColor, h1Color } = useContext(ThemeContext);
  if (!show) {
    return null;
  }
  return createPortal(
    <div
      className="protocol"
      style={{
        backgroundColor: alpha(componentColor, 1),
        color: alpha(h1Color, 1)
      }}
    >
      <h1 className="protocol-h1">
        <button
          className="album-button protocol-h1-button"
          onClick={props.close}
        >
          {intl.get('Back')}
        </button>
        《即享服务使用协议》
      </h1>
      <article>
        <p className="black">
          欢迎您使用即刻分享信息技术（北京）有限公司提供的服务（以下简称“本服务”）！
        </p>
        <p className="black">
          为方便您使用相关服务，请您务必仔细阅读本协议的全部内容，如果您不接受本协议条款，您应立即停止使用本服务，如您点击同意本协议或继续使用本服务，即视为您已理解并接受本协议所有条款。
        </p>
        <p className="title">一、定义</p>
        <p>1、 本协议：指本协议正文、《即享服务使用协议》。</p>
        <p>
          2、
          服务提供方：指向您提供服务的即刻分享信息技术（北京）有限公司，在本协议中简称为“即享”。
        </p>
        <p>
          3、
          服务：即享向您提供的功能，具体包括：照片浏览，获取照片大图，照片下载，历史访问记录，人脸识别等。其中人脸识别功能包括：上传本人照片、本人照片识别、上传好友照片、好友照片识别、添加好友、查看所公开的其他人脸照片等。
        </p>
        <p>4、 您：称为用户，指被授权使用即享功能及其服务的自然人。</p>
        <p>5、 照片著作权和所有权：属于活动主办方和即享。</p>
        <p>6、 照片肖像权：属于照片中的人物。</p>
        <p>
          7、
          服务数据：指您在使用这个服务过程中产生的被服务器记录的各种数据，包括但不限于行为记录，照片保存，浏览数据等数据。
        </p>
        <p className="title">二、 您的权利与义务</p>
        <p>
          1.
          您充分理解并同意：一旦您进入本服务的使用界面并进行后续操作，则视为您已理解并接受本协议所有条款。
        </p>
        <p>
          2.
          您充分理解并同意：照片中的肖像权属于照片中的人物，您在使用本服务过程中可能获取了他人照片。但其权利归属并没有因此而改变，如果您要下载并使用时，需取得相关权利人的同意和授权。
        </p>
        <p>
          3.
          您应对通过即享及其相关服务了解、接收或可接触到的包括但不限于其他用户在内的任何个人信息予以充分尊重，您不应以搜集、复制、存储、传播或以其他任何方式使用其他用户的信息，否则，由此产生的后果由您自行承担。
        </p>
        <p>
          4.
          您充分理解并同意：即享人脸识别功能会尽最大能力提供准确的人脸识别对比服务，并通过改进识别程序来不断提高识别准确度，但始终存在较小的识别错误或识别遗漏的情况，这种情况从而导致您所检索出来的照片中，错误或者遗漏实际有您的照片。您看到识别出来的结果为有您但实际上不是您的照片，他人看到识别出来的结果为他人但实际上为您的照片。
        </p>
        <p>
          5.
          您应对自己上传到本服务的数据来源及内容负责，即享提示您谨慎判断数据来源及内容的合法性。因您上传、储存的数据及内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。
        </p>
        <p>
          6.
          您充分理解并同意：本服务主要是程序对您和活动主办方授权的即享所上传的保存在即享云端的照片，图像、数据等内容的访问以及对这些信息进行加工分析。即享保证这些信息收集用于应用程序运行及功能实现目的。
        </p>
        <p>
          7.
          您充分理解并同意：在法律法规允许的范围内，即享有权基于为更好地向您提供服务之目的，保留随时修改、取消、增加本服务一项或多项功能或全部服务的权利，以及保留并使用您在使用本服务过程中产生的相关数据信息。
        </p>
        <p>
          8.
          您充分理解并同意：即享内部可能会使用主办方授权公开的相册中您或您提供的照片文件，报告记录，数据信息，系统使用情况等内容来改进系统服务能力，包括但不限于训练和测试机器学习模型，对比试验新型算法等。
        </p>
        <p>
          9.
          您充分理解并同意：您不会对本服务进行任何破坏或试图破坏网络安全的行为（包括但不限于钓鱼、黑客、网络诈骗、网站或空间中含有或涉嫌散播：病毒，木马，恶意代码，及通过虚拟服务器对其他网站、服务器进行涉嫌攻击行为如扫描、嗅探、ARP欺骗、DDoS等）。
        </p>
        <p>
          10.
          您充分理解并同意：您在使用本服务时实施的所有行为均应当遵守国家法律、法规、并遵守本协议的相关规定，即享有权依合理判断对违反有关法律法规或本协议规定的行为进行处理，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一些法律责任。
        </p>
        <p>
          11. 您应规范、合法地使用本服务，不得实施任何违法违规，包括但不限于：
        </p>
        <p>1) 违反宪法规定的基本原则的；</p>
        <p>2) 危害国家统一，主权和领土完整的；</p>
        <p>
          3) 煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；
        </p>
        <p>4) 宣扬邪教、迷信的；</p>
        <p>5) 违背社会公德的；</p>
        <p>
          6)
          利用本服务上传、传播、储存侵害他人知识产权、商业机密权、肖像权、隐私等合法权利的内容；
        </p>
        <p>7) 违反法律或本协议约定超出范围内使用用户数据；</p>
        <p>8) 实施其他违法违规行为。</p>
        <p>
          12.
          您充分理解并同意：虽然即享会尽最大努力保护所有用户的合法权益并主动检测所上传内容的合法性，但即享无法完全阻止用户上传、发布、传播侵权或非法内容，若接到此类情况的投诉，即享有权根据有关法律法规或本协议规定的对涉及的照片采取中止、屏蔽、删除等措施，并可根据司法机关要求进行数据提取、内容屏蔽或删除相关内容，不对您或其他用户承担任何责任。
        </p>
        <p>
          13.
          除非有法律允许或即享书面许可，您在使用即享服务过程中有如下任何行为的，即享有权视情节严重程度，依据本协议相关规定，对您随时中断或终止您使用该服务而无须通知您，如给即享造成损失的，即享有权要求您赔偿损失。情节严重的将移交有关行政管理机关给予行政处罚，或者追究您的刑事责任：
        </p>
        <p>
          1)
          以某种方式暗示或伪称即享内部员工或某种特殊身份，企图得到不正当利益或影响其他用户权益的行为；
        </p>
        <p>
          2)
          对这项服务进行逆向工程，反向汇编，反向编译或试图以其他方式尝试发现本服务的源代码，或任何改变或试图改变即享提供的系统配置或破坏系统安全的行为；
        </p>
        <p>
          3)
          对此项服务进行修改，翻译，改编，出租，转许可，在信息网络上传播或转让即享提供的软件或服务，扫描，探查，测试，以检测，发现，查找其中可能存在的bug或弱点；
        </p>
        <p>4) 在即享服务中使用非法或不正当词语，字符等；</p>
        <p>
          5)
          以任何方式破坏即享服务，包括但不限于您的设备或帐号遭遇计算机病毒、木马、恶意代码、网络入侵和攻击破坏（包括但不限于DDOS）等危害网络安全事项或行为，或影响即享服务的正常进行；
        </p>
        <p>6) 其他未经即享明示授权的行为。</p>
        <p>
          14.
          您充分理解并同意：本服务目前是即享免费提供的，即您开通或使用本服务时，并不需向即享支付使用本服务所产生的所有费用。您在使用本服务过程中产生的网络通信流量等仍需按相应服务供应商的收费标准正常付费。即享不排除日后针对本服务有收取费用的可能性，届时即享将通过在即享相册或网站内发布公告或推送通知等方式公布收费标准及规范。如您仍继续使用本服务，应按届时有效的收费标准付费并应遵守相关服务条款。如在收费后，您拒绝支付费用的，即享有权不再向您提供服务，并有权不再继续保留您的业务数据。
        </p>
        <p className="title">三、即享的权利与义务</p>
        <p>
          1.
          即享在技术上维护本服务的系统安全、有效、正常运行，使您能够顺利使用本协议约定服务。
        </p>
        <p>
          2.
          为向您提供更加完善的服务，即享有权随时自主决定对本服务的界面、使用规则等进行优化和调整，并且即享有权变更、调整具体类型和范围。
        </p>
        <p>
          3.
          即享有权在必要时单方决定修改本协议条款，修改后的协议将会明确提示，并需要用户重新确认。如果您不接受修改后的协议，可停止使用本服务。如果继续使用本服务，则视为您对相关修改的理解和接受。
        </p>
        <p>
          4.
          保护用户数据是即享的一项基本原则，除本服务的特定应用中或法律或有法律赋予权限的政府部门要求或用户同意等合理原因外，未经您的同意，即享不会向任何他方公开、透露您的信息，以下情形除外：
        </p>
        <p>1) 您同意即享向第三方提供的；</p>
        <p>
          2)
          依据法律法规的规定，或依据本协议或其他相关协议、规则等规定可以提供的；
        </p>
        <p>
          3)
          为解决用户投诉、举报事件、提起诉讼而需要提供的（包括但不限于向服务商提供您的数据信息、投诉通知和要求等，或依据行政、司法等政府部门要求提供您的信息等）；
        </p>
        <p>
          4)
          为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提供的。
        </p>
        <p>
          5.
          即享可能因服务器bug、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的数据发生异常。在数据异常的原因未得到查明前，即享有权关闭此项服务，若查明数据异常为非正常操作行为所致，即享有权恢复数据至数据异常发生前的原始状态（包括向第三方追回被转移数据），且即享无须向您承担任何责任。
        </p>
        <p>
          6.
          您充分理解并同意：受技术所限，即享无法保证其所提供的服务没有瑕疵，但即享承诺将不断提升服务质量及服务水平，为您提供更加优质的服务。据此，您同意：如果即享所提供的服务虽然存在瑕疵，但该等瑕疵是当时行业技术水平所无法避免的，其将不被视为即享违约。
        </p>
        <p>
          7.
          您充分理解并同意：虽然即享会尽一切可能提供服务的可用性和可靠性，但即享将不对任何服务的可用性、可靠性做出承诺，即享也不对您使用本服务所导致的争议、损失或其他结果承担任何责任。
        </p>
        <p className="title">四、信息安全</p>
        <p>
          即享使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，当您进入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
        </p>
        <p className="title">五、其他</p>
        <p>
          1.
          您通过本服务上传页面点击确认同意的方式选择接受本协议，即表示您与即享已达成协议并同意接受本协议的全部约定内容。本协议自您确认接受之时起，或自您以任何方式使用本服务时（以时间在先者为准）生效。即享有权在必要时修改本协议条款，您可以在相关页面中查阅最新的协议条款。本协议条款变更后，如果您继续使用本服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本服务。
        </p>
        <p>
          2.
          因不可抗力或者其他意外事件，使得本服务协议的履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。
        </p>
        <p>
          3.
          不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、黑客、网路堵塞、电信部门技术调整和政府管制等。
        </p>
        <p>
          4.
          本服务协议的订立、执行和解释及争议的解决均受中华人民共和国法律管辖。
        </p>
        <p>
          5.
          若因本协议发生任何纠纷或争议，双方应及时协商解决。协商不成时，任何一方可向本协议签订地有管辖权的人民法院解决。
        </p>
        <p>
          6.
          本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
        </p>
      </article>
      <footer style={{ textAlign: 'right', marginTop: 30 }}>
        即刻分享信息技术（北京）有限公司
      </footer>
    </div>,
    containerEl
  );
};
export default Protocol;
